<!-- <div class="about-title about-title-bg">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="about-title-text">
                    <h2>About Us</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-rounded-double-right"></i> About Us</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div> -->

<section class="about-style-two about-style-three pt-100 pb-70">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-6 p-0">
                <div class="about-img">
                    <!-- <img src="assets/img/about-two.png" alt="about image"> -->
                    <img src="assets/img/photo/about.jpg" alt="about image">
                </div>
            </div>

            <div class="col-lg-6">
                <div class="about-text">
                    <div class="section-head">
                        <!-- <h2>We have been doing projects since 2008.</h2> -->
                        <p>HIKMATEX group includes two other companies AIRTIS and SINTEMA, it is the first manufacturer of mattress fabrics and fabrics for tents in Morocco.</p>
                        <p class="mt-2">The group is committed to the satisfaction of its customers while respecting the environment, sustainable development, social protection and the development of human resources.</p>
                        <p class="mt-2">The HIKMTAEX group, Moroccan weaving companies, citizens and responsible, together with our customers, our suppliers and our partners to develop a great sector and ensure the sustainability and transmission of a national know-how in the field of weaving.</p>
                        <p class="mt-2">The group's mission is to ensure the sustainability, profitability and efficiency of the organization while respecting its commitments and contributing to the well-being of its staff in transparency and equity.</p>
                    </div>
                    <div class="theme-button">
                        <a routerLink="/products" class="default-btn">Our product</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
